export default {"src":"/_next/static/media/user-icon.4e707d9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};